/* Street Game Rewards — Shopify section engine
 * Reads config + asset URLs from the JSON emitted by sections/street-game-rewards.liquid.
 * Supports one instance per page (full-viewport arcade section).
 */
(() => {
  "use strict";

  const root = document.querySelector("[data-sg-root]");
  if (!root || root.dataset.sgInit) return;
  root.dataset.sgInit = "1";

  const CFG = JSON.parse(root.querySelector("[data-sg-config]").textContent);
  const byId = (n) => root.querySelector('[data-sg-id="' + n + '"]');

  // ---------- username suggestion pool ----------
  const SG_USERNAMES = ["kai_streets","mias.world","dripcollector","nyc.noah","lupita.x","theo.skates","aria_j","the.plug","soleful.sam","ollie.otis","grip_tape_g","curb.cutter","zayn.rolls","nina_nollie","bkbound","deck.dweller","rico.grinds","vela_v","tarmac.teo","juno.kicks","sk8.sana","milo_manual","fifth.ave.finn","waxed.rails","priya.pops","dex_downtown","kerb.king","lola.laces","omar.ollies","stitch_and_sole","ravi.rolls","queens.quinn","nova_nyc","tread.marks","basim.board","elle.everyday","coping.clara","yuki_yards","harlem.hana","sole.searcher","tomas.tre","indie_inks","axel.asphalt","brixx.beau","mika.midtown","fresh_off_rack","dario.drops","selby.streets","lane.splitter","ozzy_ollie","cass.concrete","threadcount.tia","nico.nosegrind","soho.sione","raul_rails","bea.bearings","kickflip.kj","urbn_ollie","maya.manuals","dusty.decks","leo.ledges","hemline_hux","sasha.slides","grind.gospel","pavel.pivots","lux_lowtops","tara.tailslide","crosswalk.cai","ellis.edges","denim_dax","rio.railslide","stoop.kid.sy","amara.airs","fitcheck.fai","kenji.kicks","blocktoparty","vic.vertramp","laced_lena","rome.rollaway","subway.surfa","noor.nightskate","cuffed_cole","izzy.impossible","gutterball.gia","hank.halfcab","overdye_ovi","suri.switch","latenight.lex","zeke.zoom","raw_hem_rhea","pia.pressflip","bodega.bex","malik.melon","stitchwork.stu","ines.indy","rooftop.rhy","juno.jamz","fadeaway_faz","opal.ollie","eastside.eli","sillage.sam","topnote.tara","drydown.dee","basenote_bea","oud.obsessed","amber.hour","vanilla.vex","musk.maven","projection.pia","blindbuy.bex","decant.dex","layering.lex","the.nose.knows","scent.strip","longevity.lu","eau.de.evie","parfum.pax","notes.on.nia","whiff.wren","aroma.ari","miami.mode","santorini.sol","ibiza.afterdark","paris.pending","london.drizzle","bangkok.bound","venice.veil","manila.midnight","capetown.cass","vegas.velvet","amsterdam.ash","auckland.ava","singapore.sky","mauritius.mae","hawaii.haze","nyc.nocturne","lisbon.lux","seoul.sillage","tangier.trace","havana.hux","velvet.void","goldenhour.gia","afterhours.axel","neon.nadia","silk.static","midnight.mila","bloom.bex","ember.eve","halo.hux","plush.pia","noir.nico","dusk.dara","lush.lior","satin.sy","opal.ora","drift.dey","35percent.club","spray.and.pray","two.spritz.tia","wrist.test.wes","smells.like.rio","bottle.hoarder","fullbottle.fai","sample.size.sana","top.of.the.note","scent.twin","nose.blind.nyx","one.more.spritz","vela","juno","rome","nyra","calla","sable","onyx","wren","lior","cove","isla","zayn"];
  const USERNAMES_ENDPOINT = CFG.usernamesEndpoint || null;
  const SG_USED_KEY = "sg_used_names_v1"; // fallback when no endpoint
  let selectedUsername = ""; // set when user picks from dropdown

  function sgLocalGetUsed(){ try{ return JSON.parse(localStorage.getItem(SG_USED_KEY)||"[]"); }catch(_){ return []; } }
  function sgLocalMarkUsed(name){ try{ const u=sgLocalGetUsed(); if(!u.includes(name)){ u.push(name); localStorage.setItem(SG_USED_KEY,JSON.stringify(u)); } }catch(_){} }

  function sgPickRandom(pool, count){
    const pick=[], tmp=[...pool];
    const n=Math.min(count, tmp.length);
    for(let i=0;i<n;i++){ const idx=Math.floor(Math.random()*tmp.length); pick.push(tmp.splice(idx,1)[0]); }
    return pick;
  }

  function sgMarkUsedInDB(name){
    if(USERNAMES_ENDPOINT){
      try{ fetch(USERNAMES_ENDPOINT,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({action:"claim",name})}); }catch(_){}
    } else {
      sgLocalMarkUsed(name);
    }
  }

  function sgBuildDropdownUI(names){
    // Remove any previously injected dropdown
    document.querySelectorAll(".sg-injected-dd").forEach(el=>el.remove());

    const formStep = root.querySelector('.cstep[data-step="form"]');
    if(!formStep || !names.length) return;

    // Build wrapper — mirrors .field layout (flex column, gap 6px, left-aligned)
    const wrap = document.createElement("div");
    wrap.className = "sg-injected-dd field sg-dd-wrap";

    // Label row
    const lbl = document.createElement("div");
    lbl.className = "sg-dd-label";
    lbl.textContent = "USERNAME";
    wrap.appendChild(lbl);
    const lblSub = document.createElement("div");
    lblSub.className = "sg-dd-label-sub";
    lblSub.textContent = "Final. No do-overs.";
    wrap.appendChild(lblSub);

    // Trigger button
    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "sg-dd-trigger";
    trigger.setAttribute("aria-expanded","false");
    trigger.innerHTML = `<span class="sg-dd-val">— pick a username —</span><svg class="sg-dd-arrow" viewBox="0 0 12 8" width="12" height="8"><path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>`;
    wrap.appendChild(trigger);

    // Options list
    const list = document.createElement("div");
    list.className = "sg-dd-list";
    names.forEach(n=>{
      const btn = document.createElement("button");
      btn.type="button"; btn.className="sg-dd-item"; btn.textContent=n;
      btn.addEventListener("click",()=>{
        selectedUsername = n;
        trigger.querySelector(".sg-dd-val").textContent = n;
        wrap.classList.remove("sg-dd-open");
        trigger.setAttribute("aria-expanded","false");
        sgMarkUsedInDB(n);
      });
      list.appendChild(btn);
    });
    wrap.appendChild(list);

    // Toggle open/close
    trigger.addEventListener("click",(e)=>{
      e.stopPropagation();
      const open = wrap.classList.toggle("sg-dd-open");
      trigger.setAttribute("aria-expanded",String(open));
    });
    document.addEventListener("click",(e)=>{
      if(!wrap.contains(e.target)){
        wrap.classList.remove("sg-dd-open");
        trigger.setAttribute("aria-expanded","false");
      }
    });

    // Insert before the error div
    const errDiv = formStep.querySelector(".cerr");
    if(errDiv){ formStep.insertBefore(wrap, errDiv); }
    else { formStep.appendChild(wrap); }
  }

  function renderNameSuggestions(){
    if(USERNAMES_ENDPOINT){
      fetch(`${USERNAMES_ENDPOINT}?action=suggest&count=5`)
        .then(r=>r.json())
        .then(j=>{ sgBuildDropdownUI(Array.isArray(j.names)?j.names:[]); })
        .catch(()=>{ sgBuildDropdownUI([]); });
    } else {
      const used = sgLocalGetUsed();
      const pool = SG_USERNAMES.filter(n=>!used.includes(n));
      sgBuildDropdownUI(sgPickRandom(pool,5));
    }
  }

  // ---- sprites (theme asset URLs from config) ----
  const SPRITE_DATA = CFG.assets.sprites; // {idle,run,jump,slide,roll,victory,barrier,cone,barrel,crate,slab,coin,bigcoin,gem,magnet}
  const SP = {};
  let spritesReady = 0, spritesTotal = Object.keys(SPRITE_DATA).length;
  Object.entries(SPRITE_DATA).forEach(([k, src]) => {
    SP[k] = new Image();
    SP[k].onload = () => { spritesReady++; };
    SP[k].src = src;
  });
  function charReady(){ return spritesReady >= spritesTotal; }

  // ---------- config (from section settings) ----------
  const START_LIVES = CFG.lives;
  // Endless mode — speed ramps smoothly with time, no fixed levels
  const ENDLESS_START_SPEED = 330;
  const ENDLESS_MAX_SPEED   = 720;
  const COIN_BASE = 30;
  const MULT_CAP = 5;
  const T = CFG.text;                   // UI strings

  // ---------- dom ----------
  const stage = byId("stage");
  const cv = byId("game");
  const ctx = cv.getContext("2d");
  const veil = byId("veil");
  const startBtn = byId("startBtn");
  const pauseBtn = byId("pauseBtn");
  const resumeBtn = byId("resumeBtn");
  const hudPoints = byId("hudPoints");
  const hudHits = byId("hudHits");
  const hudRank = byId("hudRank");
  const chipPts = byId("chipPts");
  const sumPts = byId("sumPts");
  const sumRank = byId("sumRank");
  const sumLbl = byId("sumLbl");
  const sumJoin = byId("sumJoin");
  const ladderFill = byId("ladderFill");
  const ladderNodes = byId("ladderNodes");
  const nextPerk = byId("nextPerk");
  const toast = byId("toast");
  const toastName = byId("toastName");
  const toastPerk = byId("toastPerk");
  const srLive = byId("srLive");

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Endless mode — ladder not used

  // ---------- lives hearts ----------
  const hudLives = byId("hudLives");
  const HEART = '<svg viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#FF3B4E" stroke="#B71C2C" stroke-width="1.4" stroke-linejoin="round"/><path d="M7.4 6.2C6 6.4 5 7.5 5 9" fill="none" stroke="#ffd0d6" stroke-width="1.6" stroke-linecap="round" opacity=".85"/></svg>';
  const heartEls=[];
  for(let i=0;i<START_LIVES;i++){ const h=document.createElement("span"); h.className="hb"; h.innerHTML=HEART; hudLives.appendChild(h); heartEls.push(h); }
  function syncLives(){ heartEls.forEach((h,i)=> h.classList.toggle("lost", i>=G.lives)); }
  function flashHearts(){ const h=heartEls[G.lives]; if(h){ h.classList.remove("flash"); void h.offsetWidth; h.classList.add("flash"); } }

  // ---------- sizing ----------
  let W=0, H=0, DPR=1, ground=0;
  // ---- cached glows / gradients (perf: avoid per-frame gradient allocs) ----
  function makeGlow(radius, rgb, peak){
    const s=Math.ceil(radius*2), c=document.createElement('canvas'); c.width=c.height=s;
    const g=c.getContext('2d');
    const grd=g.createRadialGradient(radius,radius,radius*0.05,radius,radius,radius);
    grd.addColorStop(0,'rgba('+rgb+','+peak+')'); grd.addColorStop(1,'rgba('+rgb+',0)');
    g.fillStyle=grd; g.fillRect(0,0,s,s); return c;
  }
  const COIN_GLOW=makeGlow(64,'255,215,0',0.45);
  const STEAM_GLOW=makeGlow(64,'216,222,232',1);
  let groundGrad=null, groundGradH=-1;
  const bgImg = new Image(); if (CFG.assets.bg) bgImg.src = CFG.assets.bg;
  function resize(){
    const _coarse = (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) || Math.min(window.innerWidth, window.innerHeight) <= 640;
    DPR = Math.min(window.devicePixelRatio || 1, _coarse ? 1.5 : 2);
    W = stage.clientWidth; H = stage.clientHeight;
    cv.width = Math.floor(W*DPR); cv.height = Math.floor(H*DPR);
    ctx.setTransform(DPR,0,0,DPR,0,0);
    ground = H * 0.80;
    buildSkyline();
  }

  // ---------- world / state ----------
  const LS_BEST = "sg_best_" + (CFG.sid||"");
  let _best = 0; try{ _best = parseInt(localStorage.getItem(LS_BEST)||"0",10)||0; }catch(_){}
  const G = {
    state:"ready", best:_best,  // ready | playing | paused
    points:0, displayPoints:0,
    streak:0, mult:1, level:0, lives:START_LIVES, coupon:false,
    speed:330, baseSpeed:330,
    dist:0, t:0, shake:0, invuln:0,
    drops:[], cones:[], taxis:[], parts:[], floats:[], steam:[], vents:[],
    spawnDrop:0, spawnCone:0, spawnVent:0, spawnTaxi:0,
  };

  // skater girl sprite
  const R = {
    x:0, y:0, vy:0, w:104, h:131, onGround:true,
    jumpsHeld:false, jumpBuf:0, coyote:0, sx:1, sy:1, runT:0,
  };
  function resetRunner(){ R.y = ground - R.h; R.vy=0; R.onGround=true; }

  // ---------- daytime city ----------
  let cityFar=[], cityNear=[], clouds=[], cityFarSpan=0, cityNearSpan=0;
  let parFar=0, parNear=0, parGround=0, cloudPar=0;
  function rnd(a,b){return a+Math.random()*(b-a);}
  function pick(a){return a[Math.floor(Math.random()*a.length)];}
  function shade(hex, amt){ const n=parseInt(hex.slice(1),16); let r=n>>16&255,g=n>>8&255,b=n&255;
    const f=amt<0?0:255, t=Math.abs(amt);
    r=Math.round(r+(f-r)*t); g=Math.round(g+(f-g)*t); b=Math.round(b+(f-b)*t);
    return `rgb(${r},${g},${b})`; }

  const NEON=['#ff2e6e','#1fb6ff','#ffd400','#19d36b','#a64bff','#ff6a00','#00d6c2','#ff3b3b'];
  function billboard(g,x,y,w,h,seed){
    const bg=NEON[seed%NEON.length];
    g.fillStyle='#0c0c10'; g.fillRect(x-2,y-2,w+4,h+4);
    g.fillStyle=bg; g.fillRect(x,y,w,h);
    g.save(); g.beginPath(); g.rect(x,y,w,h); g.clip();
    const m=seed%4, c2=NEON[(seed+3)%NEON.length];
    if(m===0){ g.fillStyle='rgba(255,255,255,.85)'; const s=Math.max(7,w/6); for(let i=0;i<w;i+=s*2) g.fillRect(x+i,y,s,h); }
    else if(m===1){ g.fillStyle='rgba(255,255,255,.92)'; g.beginPath(); g.arc(x+w/2,y+h/2,Math.min(w,h)*0.34,0,6.28); g.fill();
      g.fillStyle=bg; g.beginPath(); g.arc(x+w/2,y+h/2,Math.min(w,h)*0.18,0,6.28); g.fill(); }
    else if(m===2){ g.fillStyle=c2; g.fillRect(x,y+h*0.52,w,h*0.48);
      g.fillStyle='rgba(255,255,255,.9)'; g.fillRect(x+w*0.1,y+h*0.18,w*0.34,h*0.24); g.fillRect(x+w*0.56,y+h*0.6,w*0.3,h*0.22); }
    else { g.fillStyle='rgba(255,255,255,.85)'; for(let i=-h;i<w;i+=16){ g.beginPath();
      g.moveTo(x+i,y); g.lineTo(x+i+8,y); g.lineTo(x+i+8+h/2,y+h/2); g.lineTo(x+i+8,y+h); g.lineTo(x+i,y+h); g.lineTo(x+i+h/2,y+h/2); g.closePath(); g.fill(); } }
    g.restore();
    g.fillStyle='rgba(255,255,255,.16)'; g.fillRect(x,y,w,h*0.24);
    g.strokeStyle='rgba(255,255,255,.45)'; g.lineWidth=1; g.strokeRect(x+.5,y+.5,w-1,h-1);
    if(seed%2===0){ g.fillStyle='rgba(255,240,180,.95)';
      for(let bx=x;bx<x+w;bx+=10){ g.beginPath(); g.arc(bx,y,1.4,0,6.28); g.fill(); g.beginPath(); g.arc(bx,y+h,1.4,0,6.28); g.fill(); } }
  }
  function windowGrid(g, base, x0, y0, w, h, floorH){
    const lits=['#d3e6f2','#bcd5e6','#a6c2d6'], darks=['#5a6c7e','#475768'];
    const mx=Math.max(3,w*0.08), innerW=w-mx*2, cols=Math.max(2,Math.floor(innerW/14));
    const colGap=innerW/cols, ww=colGap*0.6, wh=floorH*0.62;
    for(let fy=y0+6; fy<y0+h-8; fy+=floorH){
      g.globalAlpha=.4; g.fillStyle=shade(base,-.3); g.fillRect(x0,fy+floorH-3,w,1.2); g.globalAlpha=1;
      for(let ci=0;ci<cols;ci++){ const wx=x0+mx+ci*colGap+(colGap-ww)/2, q=Math.random();
        g.fillStyle=q<0.07?'#ffe2a0':q<0.3?pick(darks):pick(lits); g.fillRect(wx,fy,ww,wh);
        g.fillStyle='rgba(255,255,255,.16)'; g.fillRect(wx,fy,ww,1.2); } }
  }
  function makeBuilding(w, bodyH, type, hazed){
    const crownMap={onetimes:76, empire:92, chrysler:100, billboard:22, brickbb:54, glassbb:26, slab:28};
    const crownH = crownMap[type] ?? 28;
    const cw=w, ch=Math.round(bodyH+crownH), top=crownH;
    const c=document.createElement('canvas'); c.width=Math.round(cw*DPR); c.height=Math.round(ch*DPR);
    const g=c.getContext('2d'); g.scale(DPR,DPR);
    let seed=Math.floor(Math.random()*1000);
    const basePal={onetimes:'#2b2f3a', billboard:'#23252e', empire:'#d9c3a0',
                   chrysler:'#6f7f93', brickbb:'#b0664a', glassbb:'#8fb0c6', slab:'#9aa1a8'};
    const base=basePal[type]||'#9aa1a8';
    const bg=g.createLinearGradient(0,0,cw,0);
    bg.addColorStop(0,shade(base,.15)); bg.addColorStop(.5,base); bg.addColorStop(1,shade(base,-.2));
    g.fillStyle=bg; g.fillRect(0,top,cw,bodyH);

    if(type==='billboard' || type==='onetimes'){
      const pad=Math.max(5,cw*0.07), bw=cw-pad*2, panelH=Math.min(74, bodyH*0.2);
      let by=top + (type==='onetimes'? bodyH*0.2 : 10);
      while(by < top+bodyH-28){
        if(Math.random()<0.4 && bw>96){ const half=(bw-8)/2;
          billboard(g, pad, by, half, panelH, seed++); billboard(g, pad+half+8, by, half, panelH, seed++); }
        else billboard(g, pad, by, bw, panelH, seed++);
        by += panelH + 8;
      }
      if(type==='onetimes'){
        windowGrid(g, base, 0, top, cw, bodyH*0.2, 16);
        const cx=cw*0.5; g.fillStyle='#3a3f4a'; g.fillRect(cx-2, top-46, 4, 46);
        const ball=g.createRadialGradient(cx-3,top-52,1,cx,top-49,11);
        ball.addColorStop(0,'#ffffff'); ball.addColorStop(.5,'#cfe8ff'); ball.addColorStop(1,'#6fa8d8');
        g.fillStyle=ball; g.beginPath(); g.arc(cx,top-49,11,0,6.28); g.fill();
        g.fillStyle='rgba(255,255,255,.55)'; g.beginPath(); g.arc(cx-3,top-52,3,0,6.28); g.fill();
      } else { g.fillStyle=shade(base,-.2); g.fillRect(0,top-8,cw,8); }
    } else if(type==='empire'){
      windowGrid(g, base, 0, top, cw, bodyH, 18);
      g.fillStyle=shade(base,.08);
      for(let ci=cw*0.12; ci<cw*0.9; ci+=cw*0.16) g.fillRect(ci-1.5, top+6, 3, bodyH-12);
      billboard(g, cw*0.15, top+bodyH-56, cw*0.7, 32, seed++);
      let sw=cw*0.66, sx=(cw-sw)/2;
      for(let k=0;k<3;k++){ g.fillStyle=shade(base,.04-k*0.05); g.fillRect(sx, top-14*(k+1), sw, 16); sw*=0.62; sx=(cw-sw)/2; }
      g.fillStyle='#b9c2cc'; g.fillRect(cw/2-2, top-58, 4, 18);
      g.fillStyle='#8c96a1'; g.fillRect(cw/2-1, top-80, 2, 24);
    } else if(type==='chrysler'){
      windowGrid(g, base, 0, top, cw, bodyH, 16);
      const cx=cw*0.5; let aw=cw*0.8, ah=20, ay=top;
      for(let k=0;k<4;k++){
        g.fillStyle=shade('#b6c3d0', -0.05*k);
        g.beginPath(); g.moveTo(cx-aw/2, ay); g.quadraticCurveTo(cx, ay-ah*1.7, cx+aw/2, ay); g.closePath(); g.fill();
        g.fillStyle='#33424f';
        for(let tx=cx-aw/2+7; tx<cx+aw/2-7; tx+=11){ g.beginPath(); g.moveTo(tx,ay-2); g.lineTo(tx+4,ay-11); g.lineTo(tx+8,ay-2); g.closePath(); g.fill(); }
        aw*=0.72; ay-=ah*0.82;
      }
      g.fillStyle='#cdd7e0'; g.fillRect(cx-1.5, ay-30, 3, 34);
      g.fillStyle='#8c96a1'; g.fillRect(cx-0.8, ay-46, 1.6, 18);
    } else if(type==='brickbb'){
      windowGrid(g, base, 0, top, cw, bodyH, 18);
      g.strokeStyle='rgba(25,20,18,.5)'; g.lineWidth=1.4; const ex=cw*0.5; g.beginPath();
      for(let yy=top+26,k=0; yy<top+bodyH-30; yy+=16,k++){ const d=k%2?-1:1;
        g.moveTo(ex-13,yy); g.lineTo(ex+13,yy); g.moveTo(ex+13*d,yy); g.lineTo(ex-13*d,yy+16); }
      g.stroke();
      g.fillStyle=shade(base,-.3); g.fillRect(-2, top-6, cw+4, 8);
      billboard(g, cw*0.12, top-40, cw*0.76, 30, seed++);
      g.fillStyle='#2e3138'; g.fillRect(cw*0.2, top-10, 3, 12); g.fillRect(cw*0.8-3, top-10, 3, 12);
    } else if(type==='glassbb'){
      const lits=['#bcd9ea','#a6c6da'];
      for(let fy=top+10; fy<top+bodyH-66; fy+=14){ g.fillStyle=pick(lits); g.fillRect(cw*0.08,fy,cw*0.84,9);
        g.fillStyle='rgba(255,255,255,.12)'; g.fillRect(cw*0.08,fy,cw*0.84,2); }
      billboard(g, cw*0.06, top+bodyH-62, cw*0.88, 42, seed++);
      g.fillStyle=shade(base,-.12); g.fillRect(6, top-10, cw-12, 10);
      g.fillStyle='#9aa3ad'; g.fillRect(cw*0.5-1.5, top-40, 3, 30);
    } else {
      windowGrid(g, base, 0, top, cw, bodyH, 18);
      if(Math.random()<0.6) billboard(g, cw*0.2, top+18, cw*0.6, 30, seed++);
      g.fillStyle=shade(base,-.14); g.fillRect(4, top-8, cw-8, 8);
    }

    g.fillStyle=shade(base,-.34); g.fillRect(0, top+bodyH-22, cw, 22);
    for(let sx=6; sx<cw-12; sx+=20){
      g.fillStyle=pick(['#ffd36a','#ff7b8a','#7fe0ff','#bdf06a']); g.fillRect(sx, top+bodyH-18, 12, 7);
      g.fillStyle='#222'; g.fillRect(sx, top+bodyH-9, 12, 7); }
    g.fillStyle=pick(['#c1463a','#2f7d52','#2b5fa6','#d98a2b']); g.fillRect(0, top+bodyH-24, cw, 3);

    if(hazed){ g.fillStyle='rgba(150,200,235,.45)'; g.fillRect(0,0,cw,ch); }
    return {canvas:c, w:cw, h:ch};
  }

  function buildSkyline(){
    cityFar=[]; cityNear=[]; clouds=[];
    const farSeq=['billboard','slab','glassbb','brickbb'];
    let x=-60, fi=0;
    while(x<W+260){ const w=rnd(80,128), h=rnd(H*0.40,H*0.60);
      cityFar.push({x, w, b:makeBuilding(w,h, farSeq[fi%farSeq.length], true)}); fi++; x += w+rnd(0,16); }
    cityFarSpan = x+60;
    const seq=['billboard','empire','billboard','chrysler','onetimes','brickbb','billboard','glassbb'];
    let ni=0; x=-90;
    while(x<W+340){
      const t=seq[ni%seq.length]; ni++;
      const tall = (t==='empire'||t==='chrysler'||t==='onetimes');
      const h = tall ? rnd(H*0.50,H*0.62) : rnd(H*0.46,H*0.72);
      const w = t==='onetimes' ? rnd(86,108) : tall ? rnd(124,158) : rnd(112,182);
      cityNear.push({x, w, b:makeBuilding(w,h,t,false)}); x += w+rnd(10,40);
    }
    cityNearSpan = x+90;
    for(let i=0;i<5;i++) clouds.push({x:rnd(0,W), y:rnd(28,H*0.32), s:rnd(0.7,1.4)});
  }

  // ---------- helpers ----------
  function rr(c,x,y,w,h,r){ r=Math.min(r,w/2,h/2); c.beginPath();
    c.moveTo(x+r,y); c.arcTo(x+w,y,x+w,y+h,r); c.arcTo(x+w,y+h,x,y+h,r);
    c.arcTo(x,y+h,x,y,r); c.arcTo(x,y,x+w,y,r); c.closePath(); }

  // ---------- input ----------
  function jump(){
    if(G.state==="ready"){ start(); return; }
    if(G.state!=="playing") return;
    if(R.onGround || R.coyote>0){ R.vy = -1080; R.onGround=false; R.coyote=0; R.jumpsHeld=true; spawnPuff(); }
    else { R.jumpBuf = .12; }
  }
  function release(){ R.jumpsHeld=false; }

  function stageEngaged(){
    if(G.state==="playing") return true;
    const r = stage.getBoundingClientRect();
    const vh = window.innerHeight || 1;
    return G.state==="ready" && r.top < vh*0.5 && r.bottom > vh*0.5;
  }
  window.addEventListener("keydown", e=>{
    if(e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    if(!stageEngaged() && G.state!=="playing") return;
    if(e.code==="Space"||e.code==="ArrowUp"||e.code==="KeyW"){ e.preventDefault(); jump(); }
    else if(e.code==="Escape" && G.state==="playing"){ pause(); }
  });
  window.addEventListener("keyup", e=>{ if(e.code==="Space"||e.code==="ArrowUp"||e.code==="KeyW") release(); });
  stage.addEventListener("pointerdown", e=>{
    if(e.target.closest("button,a")) return;
    jump();
  });
  window.addEventListener("pointerup", release);
  startBtn.addEventListener("click", e=>{ e.stopPropagation(); start(); });
  pauseBtn.addEventListener("click", pause);
  const settingsBtn = byId("settingsBtn"); if(settingsBtn) settingsBtn.addEventListener("click", pause);
  window.addEventListener("blur", ()=>{ if(G.state==="playing") pause(); });

  // ---------- landscape hint on phones (never blocks play) ----------
  const rotateEl = byId("rotate");
  let rotateDismissed = false;
  function isCoarse(){ try{ return matchMedia && matchMedia("(pointer: coarse)").matches; }catch(_){ return ("ontouchstart" in window); } }
  function isPortrait(){
    try{ return matchMedia("(orientation: portrait)").matches; }
    catch(_){ return window.innerHeight > window.innerWidth; }
  }
  function checkOrient(){
    const show = isCoarse() && isPortrait() && !rotateDismissed;
    if(rotateEl) rotateEl.classList.toggle("show", show);
    if(show && G.state==="playing") pause();
  }
  { const rg=byId("rotateGo"); if(rg) rg.addEventListener("click", (e)=>{ e.stopPropagation(); rotateDismissed=true; if(rotateEl) rotateEl.classList.remove("show"); }); }
  window.addEventListener("resize", checkOrient);
  window.addEventListener("orientationchange", ()=> setTimeout(checkOrient, 150));
  try{ matchMedia("(orientation: portrait)").addEventListener("change", ()=> setTimeout(checkOrient, 80)); }catch(_){}
  checkOrient();

  // ---------- flow ----------
  function resetGame(){
    G.points=0; G.displayPoints=0; G.streak=0; G.mult=1;
    G.lives=START_LIVES;
    G.speed=ENDLESS_START_SPEED; G.dist=0; G.t=0; G.shake=0; G.invuln=0;
    G.drops=[]; G.cones=[]; G.taxis=[]; G.parts=[]; G.floats=[]; G.steam=[]; G.vents=[];
    G.spawnDrop=.7; G.spawnCone=1.7; G.spawnVent=2; G.spawnTaxi=3;
    resetRunner(); syncLives(); syncHUD();
  }
  function start(){
    resetGame();
    veil.classList.remove("pausemode","overmode");
    veil.classList.add("hidden");
    stage.classList.add("playing");
    G.state="playing";
    last = performance.now();
  }
  function pause(){
    if(G.state!=="playing") return;
    G.state="paused";
    buildSummary(false);
    veil.classList.remove("overmode"); veil.classList.add("pausemode");
    veil.classList.remove("hidden");
  }
  function resume(){
    veil.classList.add("hidden");
    G.state="playing";
    last = performance.now();
  }
  function gameOver(){
    G.state="over";
    buildSummary(true);
    stage.classList.remove("playing");
    veil.classList.remove("pausemode"); veil.classList.add("overmode");
    veil.classList.remove("hidden");
  }
  function buildSummary(isOver){
    const pts = Math.round(G.points);
    sumPts.textContent = pts.toLocaleString();
    { const sc=pts; if(sc>G.best){ G.best=sc; try{ localStorage.setItem(LS_BEST, String(sc)); }catch(_){} } const hs=byId("hiScore"); if(hs) hs.textContent=G.best.toLocaleString(); }
    if(isOver){
      sumLbl.textContent = T.wipeout;
      sumRank.innerHTML = `${pts.toLocaleString()} coins · ${Math.min(150, Math.floor(pts/50)*25)} loyalty hits`;
      resumeBtn.textContent = T.runItBack;
      resumeBtn.onclick = start;
      sumJoin.textContent = T.claim;
      if(pts > 50){
        // enough coins — show claim, hide run again
        resumeBtn.style.display = 'none';
        sumJoin.style.display = '';
      } else {
        // not enough — hide claim, show run again
        resumeBtn.style.display = '';
        sumJoin.style.display = 'none';
      }
    } else {
      sumLbl.textContent = T.banked;
      sumRank.innerHTML = `${pts.toLocaleString()} coins · ${Math.min(150, Math.floor(pts/50)*25)} loyalty hits`;
      resumeBtn.textContent = T.keepPlaying;
      resumeBtn.onclick = resume;
      sumJoin.textContent = T.claim;
      if(resumeBtn) resumeBtn.style.display = '';
      sumJoin.style.display = pts > 50 ? '' : 'none';
    }
  }

  // ---------- claim + leaderboard ----------
  const CLAIM_CODE = CFG.code || "WELCOME10";
  const CLAIM_ENDPOINT = CFG.claimEndpoint || null;   // optional: Klaviyo/app endpoint
  const LEADERBOARD_ENDPOINT = CFG.boardEndpoint || null;
  let BOARD = LEADERBOARD_ENDPOINT ? [] : (CFG.seedBoard || []).map(r=>({name:r.name, score:r.score}));
  let myEntry=null;
  const claim=byId("claim");
  const cEmail=byId("cEmail"), cErr=byId("cErr");
  const boardList=byId("boardList");
  const boardPodium=byId("boardPodium");

  function cstep(name){ claim.querySelectorAll(".cstep").forEach(s=> s.hidden = s.dataset.step!==name); }
  function openClaim(){
    G.state="claim"; cErr.textContent=""; selectedUsername="";
    cstep("form");
    veil.classList.remove("pausemode","overmode","hidden"); veil.classList.add("claimmode");
    renderNameSuggestions();
    setTimeout(()=>{ try{cEmail.focus();}catch(_){} },60);
  }
  function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function esc(s){ return String(s).replace(/[<>&"]/g,c=>({"<":"&lt;",">":"&gt;","&":"&amp;",'"':"&quot;"}[c])); }

  const PRIZE_LABELS = ["Swag box","Jersey","Cap"];
  const PRIZE_EMOJIS = ["\uD83C\uDF81","\uD83D\uDC55","\uD83E\uDDE2"];  // 🎁 👕 🧢
  const PRIZE_RANKS  = ["1ST","2ND","3RD"];

  function rowHtml(r,i){
    const prize=i<3;
    //const pillHtml = prize ? `<span class="lb-prize-pill lb-prize-${i}">${PRIZE_LABELS[i].toUpperCase()}</span>` : '';
    const pillHtml = '';
    return `<div class="lb-row ${prize?'lb-row-prize':''} ${r.me?'lb-row-me':''}">`+
      `<span class="lb-row-rk">${i+1}</span>`+
      (prize?`<span class="lb-row-dot lb-dot-${i}"></span>`:`<span class="lb-row-dot lb-dot-x"></span>`)+
      `<span class="lb-row-nm">${esc(r.name)}</span>`+
      `${pillHtml}<span class="lb-row-sc">${r.score.toLocaleString()}</span></div>`;
  }
  function renderBoard(){
    const sorted=[...BOARD].sort((a,b)=>b.score-a.score);
    const myIdx=myEntry ? sorted.findIndex(r=>r.me) : -1;
    if(boardPodium){
      const podHtml=PRIZE_RANKS.map((rank,i)=>{
        const r=sorted[i]; if(!r) return '';
        return `<div class="lb-pod lb-pod-${i} ${r.me?'lb-pod-me':''}">`+
          `<div class="lb-pod-rank">${rank}</div>`+
          `<div class="lb-pod-icon">${PRIZE_EMOJIS[i]}</div>`+
          `<div class="lb-pod-label">${PRIZE_LABELS[i]}</div>`+
          `<div class="lb-pod-name">${esc(r.name)}</div>`+
          `</div>`;
      }).join("");
      boardPodium.innerHTML=podHtml;
    }
    let html=sorted.slice(0,8).map((r,i)=>rowHtml(r,i)).join("");
    if(myIdx>=8) html += `<div class="lb-bdiv">· · ·</div>` + rowHtml(sorted[myIdx],myIdx);
    boardList.innerHTML=html || '<div style="opacity:.5;padding:16px;text-align:center">No entries yet</div>';
  }

  function fetchAndRenderBoard(afterFetch){
    if(!LEADERBOARD_ENDPOINT){ renderBoard(); if(afterFetch) afterFetch(); return; }
    boardList.innerHTML='<div style="opacity:.5;padding:16px;text-align:center">Loading…</div>';
    fetch(LEADERBOARD_ENDPOINT)
      .then(r=>r.json())
      .then(j=>{
        if(j.ok && Array.isArray(j.entries)){
          BOARD = j.entries.map(e=>({
            name: e.name,
            score: parseInt(e.score,10),
            me: myEntry && e.name===myEntry.name && parseInt(e.score,10)===myEntry.score
          }));
        }
        renderBoard();
        if(afterFetch) afterFetch();
      })
      .catch(()=>{ renderBoard(); if(afterFetch) afterFetch(); });
  }

  byId("claimSubmit").addEventListener("click", async ()=>{
    const email = cEmail.value.trim();
    if(!validEmail(email)){ cErr.textContent="Enter a valid email address."; cEmail.focus(); return; }
    cErr.textContent="";
    const submitBtn = byId("claimSubmit");
    const origLabel = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = "Please wait…";

    const nm = selectedUsername || (email.split("@")[0]||"skater").replace(/[^a-zA-Z0-9_.]/g,"").slice(0,16) || "skater";
    const lead={ email, name:nm, coins:Math.round(G.points), coupon:G.coupon, shop:CFG.shop||"", t:Date.now() };

    // Step 1: Hit claim endpoint — server checks/creates Shopify customer then awards points.
    // Await the response so cooldown errors block the flow before advancing to share step.
    if(CLAIM_ENDPOINT){
      try{
        const res = await fetch(CLAIM_ENDPOINT,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(lead)});
        const j = await res.json();
        if(j.cooldown && j.message){
          cErr.textContent = j.message;
          submitBtn.disabled = false;
          submitBtn.textContent = origLabel;
          return;
        }
      }catch(e){}
    }

    submitBtn.disabled = false;
    submitBtn.textContent = origLabel;

    // Step 2: Save score to leaderboard and await the response so BOARD has server data before rendering
    myEntry={ name:nm, score:Math.round(G.points), me:true }; BOARD.push(myEntry);
    if(LEADERBOARD_ENDPOINT){
      try{
        const lbRes = await fetch(LEADERBOARD_ENDPOINT,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({name:nm,score:myEntry.score,email})});
        const lbJson = await lbRes.json();
        if(lbJson.ok && Array.isArray(lbJson.entries)){
          BOARD=lbJson.entries.map(e=>({name:e.name,score:parseInt(e.score,10),me:e.name===nm&&parseInt(e.score,10)===myEntry.score}));
        }
      }catch(e){}
    }
    renderBoard(); buildCard(); cstep("share"); srLive.textContent="You're on the leaderboard.";
  });
  byId("claimBack").addEventListener("click", ()=>{
    buildSummary(true); veil.classList.remove("claimmode"); veil.classList.add("overmode"); G.state="over";
  });
  byId("boardAgain").addEventListener("click", start);
  { const bb=byId("boardBack"); if(bb) bb.addEventListener("click", ()=>{ cstep("share"); }); }
  { const bd=byId("boardDone"); if(bd) bd.addEventListener("click", ()=>{
    veil.classList.remove("claimmode","overmode","pausemode","hidden"); G.state="ready"; cstep("form");
  }); }
  cEmail.addEventListener("keydown", e=>{ if(e.key==="Enter") byId("claimSubmit").click(); });

  // ---------- share card ----------
  let cardBlob=null, cardDataURL=null, cardCaption="";
  const BRAND = (T.brandName || "Street Origins");
  const BRAND_URL = ((CFG.shop||"").replace(/^https?:\/\//,"").replace(/\/$/,"").toUpperCase()) || (BRAND.replace(/\s+/g,"").toUpperCase()+".COM");
  function runReward(){ return "10% EXTRA"; }
  function crrect(x,X,Y,W,H,R){ R=Math.min(R,W/2,H/2); x.beginPath(); x.moveTo(X+R,Y); x.arcTo(X+W,Y,X+W,Y+H,R); x.arcTo(X+W,Y+H,X,Y+H,R); x.arcTo(X,Y+H,X,Y,R); x.arcTo(X,Y,X+W,Y,R); x.closePath(); }
  function buildCard(){
    const scoreStr=Math.round(G.points).toLocaleString();
    const reward=runReward();
    cardCaption="I scored "+scoreStr+" on "+BRAND+" and won "+reward+" \uD83D\uDEF9 this game is addictive af \u2014 beat me.";
    const c=document.createElement("canvas"); c.width=1080; c.height=1920; const x=c.getContext("2d");
    let g=x.createLinearGradient(0,0,0,1920); g.addColorStop(0,"#1c4bb4"); g.addColorStop(.5,"#123089"); g.addColorStop(1,"#07184a");
    x.fillStyle=g; x.fillRect(0,0,1080,1920);
    let rg=x.createRadialGradient(540,540,60,540,540,940); rg.addColorStop(0,"rgba(74,132,255,.55)"); rg.addColorStop(1,"rgba(74,132,255,0)");
    x.fillStyle=rg; x.fillRect(0,0,1080,1200);
    x.save(); x.globalAlpha=.05; x.strokeStyle="#fff"; x.lineWidth=7;
    for(let i=-1920;i<1080;i+=64){ x.beginPath(); x.moveTo(i,0); x.lineTo(i+1920,1920); x.stroke(); } x.restore();
    x.textAlign="center";
    const logo=root.querySelector(".brand .logo");
    if(logo && logo.complete && logo.naturalWidth){ const lw=640, lh=lw*(logo.naturalHeight/logo.naturalWidth); x.drawImage(logo, 540-lw/2, 150, lw, lh); }
    x.fillStyle="#a9c2ff"; x.font='800 46px "Unbounded", sans-serif'; x.fillText("I SCORED", 540, 470);
    x.save(); x.fillStyle="#fff"; x.font='900 320px "Unbounded", sans-serif'; x.shadowColor="rgba(120,170,255,.65)"; x.shadowBlur=70;
    x.fillText(scoreStr, 540, 760); x.restore();
    x.fillStyle="#a9c2ff"; x.font='700 42px "Unbounded", sans-serif'; x.fillText("POINTS", 540, 830);
    // x.font='900 60px "Unbounded", sans-serif'; const rtxt="WON "+reward; const rw=x.measureText(rtxt).width+90;
    // let gg=x.createLinearGradient(0,905,0,1009); gg.addColorStop(0,"#ffe07a"); gg.addColorStop(1,"#f5a01a");
    // x.fillStyle=gg; crrect(x,540-rw/2,905,rw,104,52); x.fill();
    // x.fillStyle="#5a3a06"; x.textBaseline="middle"; x.fillText(rtxt,540,959); x.textBaseline="alphabetic";
    // const sk=SP.run; if(sk && sk.complete && sk.naturalWidth){ const sh=520, sw=sh*(sk.naturalWidth/sk.naturalHeight); x.drawImage(sk, 540-sw/2, 1120, sw, sh); }
    const sk=SP.run; if(sk && sk.complete && sk.naturalWidth){ const sh=520, sw=sh*(sk.naturalWidth/sk.naturalHeight); x.drawImage(sk, 540-sw/2, 950, sw, sh); }
    x.fillStyle="#fff"; x.font='900 74px "Unbounded", sans-serif'; x.fillText("THIS GAME IS", 540, 1720);
    x.fillStyle="#FFC21F"; x.fillText("ADDICTIVE AF", 540, 1806);
    x.fillStyle="#8fb0ff"; x.font='700 34px "Unbounded", sans-serif'; x.fillText(BRAND_URL+"  \u00B7  BEAT MY SCORE", 540, 1878);
    const img=byId("shareImg");
    try{ cardDataURL=c.toDataURL("image/png"); if(img) img.src=cardDataURL; }catch(e){}
    try{ c.toBlob(b=>{ cardBlob=b; }, "image/png"); }catch(e){}
  }
  function downloadCard(){ if(!cardDataURL) return; const a=document.createElement("a"); a.href=cardDataURL; a.download="street-origins-score.png"; document.body.appendChild(a); a.click(); a.remove(); }
  async function shareCard(){
    try{
      if(cardBlob && navigator.canShare){ const f=new File([cardBlob],"street-origins-score.png",{type:"image/png"});
        if(navigator.canShare({files:[f]})){ await navigator.share({files:[f], text:cardCaption}); return true; } }
    }catch(e){}
    return false;
  }
  let _noteT=null;
  function shareNote(t){ const n=byId("shareNote"); if(n){ n.textContent=t; clearTimeout(_noteT); _noteT=setTimeout(()=>{n.textContent="";},3500); } }
  const APP_LINKS = {
    Instagram: { scheme:"instagram://library?OpenInMediaPicker=1", web:"https://www.instagram.com/" },
    TikTok:    { scheme:"snssdk1233://studio/upload",              web:"https://www.tiktok.com/upload" }
  };
  function openApp(app){
    const l=APP_LINKS[app]; if(!l) return;
    const started=Date.now(); let done=false;
    const onHide=()=>{ done=true; };
    document.addEventListener("visibilitychange", onHide, {once:true});
    setTimeout(()=>{ document.removeEventListener("visibilitychange", onHide);
      if(!done && !document.hidden && Date.now()-started < 1900){ window.open(l.web, "_blank", "noopener"); } }, 900);
    try{ window.location.href = l.scheme; }catch(_){ window.open(l.web, "_blank", "noopener"); }
  }
  async function shareTo(app){
    if(await shareCard()) return;
    downloadCard();
    shareNote("Card saved to your photos \u2014 opening "+app+", then pick it to post.");
    setTimeout(()=> openApp(app), 500);
  }
  byId("shareIG").addEventListener("click", ()=> shareTo("Instagram"));
  byId("shareTT").addEventListener("click", ()=> shareTo("TikTok"));
  byId("shareDL").addEventListener("click", ()=>{ downloadCard(); shareNote("Saved to your device."); });
  byId("shareBoard").addEventListener("click", ()=>{ fetchAndRenderBoard(()=>cstep("board")); });

  // ---------- leaderboard-only entry (start screen button) ----------
  function openBoard(){
    veil.classList.remove("pausemode","overmode","hidden"); veil.classList.add("claimmode");
    cstep("board"); G.state="board";
    fetchAndRenderBoard();
  }
  { const sb=byId("startBoard"); if(sb) sb.addEventListener("click", e=>{ e.stopPropagation(); openBoard(); }); }

  // ---------- spawning ----------
  function spawnPuff(){
    for(let i=0;i<8;i++) G.parts.push({
      x:R.x+R.w*.22, y:R.y+R.h, vx:rnd(-60,-160)-G.speed*.2, vy:rnd(-30,-100),
      life:rnd(.25,.5), age:0, r:rnd(1.5,3.2), col:"rgba(225,222,216,"
    });
  }
  function makeDrop(){
    const high = Math.random()<.55;
    const y = high ? rnd(ground-200, ground-120) : rnd(ground-90, ground-50);
    G.drops.push({ x:W+40, y, r:16.4, bob:Math.random()*6.28, spin:Math.random()*6.28, got:false });
  }
  function makeDropArc(){
    const n = 3+Math.floor(Math.random()*3);
    const peak = rnd(ground-210, ground-150);
    for(let i=0;i<n;i++){
      const t=i/(n-1);
      const y = ground-70 - Math.sin(t*Math.PI)*(ground-70-peak);
      G.drops.push({ x:W+40+i*46, y, r:16.4, bob:Math.random()*6.28, spin:Math.random()*6.28, got:false });
    }
  }
  function makeCone(){ const tin=Math.random()<0.5; G.cones.push({ x:W+50, w: tin?35:36, h: tin?48:43, kind: tin?'tin':'cone' }); }
  function makeTaxi(){ G.taxis.push({ x:W+80, w:101, h:53 }); }

  // ---------- particles / floats ----------
  function burst(x,y){
    for(let i=0;i<14;i++){ const a=Math.random()*6.28, s=rnd(60,220);
      G.parts.push({x,y,vx:Math.cos(a)*s,vy:Math.sin(a)*s,life:rnd(.3,.6),age:0,r:rnd(1.5,3.5),col:"rgba(255,200,97,"}); }
  }
  function floatText(x,y,txt){ G.floats.push({x,y,txt,age:0,life:.9}); }

  // ---------- update ----------
  function update(dt){
    G.t += dt;
    const target = Math.min(ENDLESS_MAX_SPEED, ENDLESS_START_SPEED + G.t * 3.8);
    G.speed += (target - G.speed) * Math.min(1, dt*1.8);
    const sc = G.speed*dt;
    G.dist += sc;

    // parallax
    parFar -= sc*0.16; parNear -= sc*0.42; parGround -= sc; cloudPar += sc;

    // runner physics
    if(!R.onGround){
      R.vy += 2700*dt;
      if(R.jumpsHeld && R.vy<0) R.vy += 0; // full hold
      if(!R.jumpsHeld && R.vy<0) R.vy += 2700*dt*1.6; // short hop
    }
    R.y += R.vy*dt;
    if(R.coyote>0) R.coyote-=dt;
    if(R.jumpBuf>0) R.jumpBuf-=dt;
    if(R.y >= ground-R.h){
      if(!R.onGround){ R.sy=.7; R.sx=1.3; landDust(); }
      R.y=ground-R.h; R.vy=0; R.onGround=true; R.coyote=.09;
      if(R.jumpBuf>0){ R.jumpBuf=0; R.vy=-1080; R.onGround=false; spawnPuff(); }
    } else { R.onGround=false; }
    // squash recover
    R.sx += (1-R.sx)*Math.min(1,dt*12);
    R.sy += (1-R.sy)*Math.min(1,dt*12);
    R.runT += dt* (R.onGround? 14 : 4);

    if(G.invuln>0) G.invuln-=dt;
    if(G.shake>0) G.shake=Math.max(0,G.shake-dt*4);

    // spawn cadence
    G.spawnDrop -= dt;
    if(G.spawnDrop<=0){ Math.random()<.45 ? makeDropArc() : makeDrop(); G.spawnDrop = rnd(.6,1.15); }
    G.spawnCone -= dt;
    if(G.spawnCone<=0){ makeCone(); G.spawnCone = rnd(1.3,2.1) * (760/G.speed); }

    // taxis appear after 30s, more frequent as game progresses
    if(G.t > 30){
      G.spawnTaxi -= dt;
      if(G.spawnTaxi<=0){ makeTaxi(); G.spawnTaxi = (G.t > 80 ? rnd(1.9,3.0) : rnd(3.0,4.6)); }
    }

    // steam vents (NYC manhole steam)
    G.spawnVent -= dt;
    if(G.spawnVent<=0){ G.vents.push({x:W+60, emit:0}); G.spawnVent = rnd(2.4,4.6); }
    for(const v of G.vents){
      v.x -= sc; v.emit -= dt;
      if(v.emit<=0){
        G.steam.push({x:v.x+rnd(-7,7), y:ground-2, age:0, life:rnd(1.6,2.7),
          r0:rnd(9,15), vy:rnd(-30,-46), drift:rnd(-6,22)});
        v.emit = rnd(.10,.20);
      }
    }
    G.vents = G.vents.filter(v=>v.x>-50);
    for(const s of G.steam){ s.age+=dt; s.y+=s.vy*dt; s.x += s.drift*dt - sc*0.55; }
    G.steam = G.steam.filter(s=>s.age<s.life);

    // drops
    const rb = {x:R.x+R.w*0.26, y:R.y+R.h*0.30, w:R.w*0.48, h:R.h*0.64};
    for(const d of G.drops){
      d.x -= sc; d.bob += dt*4; d.spin += dt*5;
      if(!d.got){
        const dy = d.y + Math.sin(d.bob)*4;
        const cx = Math.max(rb.x, Math.min(d.x, rb.x+rb.w));
        const cy = Math.max(rb.y, Math.min(dy, rb.y+rb.h));
        if((d.x-cx)**2 + (dy-cy)**2 < (d.r)**2){
          d.got=true;
          G.points += 1;
          burst(d.x, dy); floatText(d.x, dy-12, "+1");
          bump(hudPoints);
          checkLevel();
        }
      }
    }
    G.drops = G.drops.filter(d=>!d.got && d.x>-60);

    // hydrants (cost a life)
    for(const c of G.cones){
      c.x -= sc;
      if(G.invuln<=0){
        const overlapX = c.x < rb.x+rb.w && c.x+c.w > rb.x;
        const overlapY = (ground-c.h) < rb.y+rb.h && ground > rb.y;
        if(overlapX && overlapY) loseLife();
      }
    }
    G.cones = G.cones.filter(c=>c.x>-60);

    // taxis (cost a life)
    for(const t of G.taxis){
      t.x -= sc;
      if(G.invuln<=0){
        const ox = t.x < rb.x+rb.w && t.x+t.w > rb.x;
        const oy = (ground-t.h) < rb.y+rb.h && ground > rb.y;
        if(ox && oy) loseLife();
      }
    }
    G.taxis = G.taxis.filter(t=>t.x>-100);

    // particles
    for(const p of G.parts){ p.age+=dt; p.x+=p.vx*dt - sc*.15; p.y+=p.vy*dt; p.vy+=900*dt; }
    G.parts = G.parts.filter(p=>p.age<p.life);
    for(const f of G.floats){ f.age+=dt; f.y-=40*dt; }
    G.floats = G.floats.filter(f=>f.age<f.life);

    // smooth hud number
    G.displayPoints += (G.points-G.displayPoints)*Math.min(1,dt*10);
    syncHUD();
  }

  function landDust(){
    for(let i=0;i<7;i++) G.parts.push({x:R.x+rnd(0,R.w),y:ground,vx:rnd(-30,30)-G.speed*.2,vy:rnd(-10,-50),life:.4,age:0,r:rnd(2,4),col:"rgba(150,150,160,"});
  }

  // ---------- levels / lives / hud ----------
  function loseLife(){
    if(G.invuln>0 || G.state!=="playing") return;
    G.lives--; G.invuln=1.35; G.shake=1;
    syncLives(); flashHearts();
    for(let i=0;i<12;i++){ const a=Math.random()*6.28, s=rnd(80,240);
      G.parts.push({x:R.x+R.w*.5,y:R.y+R.h*.5,vx:Math.cos(a)*s,vy:Math.sin(a)*s,life:.55,age:0,r:rnd(2,4),col:"rgba(255,94,58,"}); }
    if(G.lives<=0) gameOver();
  }
  function levelBurst(){
    for(let i=0;i<26;i++){ const a=Math.random()*6.28, s=rnd(120,360);
      G.parts.push({x:R.x+R.w*.5,y:R.y+R.h*.4,vx:Math.cos(a)*s,vy:Math.sin(a)*s,life:rnd(.5,.9),age:0,r:rnd(2,4),col:"rgba(255,200,97,"}); }
  }
  function checkLevel(){ /* endless mode — no level transitions */ }
  function syncHUD(){
    hudPoints.textContent = Math.round(G.displayPoints).toLocaleString();
    hudHits.textContent = Math.min(150, Math.floor(G.points/50)*25);
    chipPts.textContent = Math.round(G.points).toLocaleString();
  }
  function showToast(t, final){
    toast.querySelector(".ru").textContent = final ? (t.name+" cleared") : "Level up";
    toastName.textContent = final ? T.finalLabel : t.name;
    toastPerk.textContent = final ? T.finalUnlockedNote : t.perk;
    toast.classList.toggle("coupon", !!final);
    toast.classList.remove("show"); void toast.offsetWidth; toast.classList.add("show");
  }
  function bump(el){ el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); }

  // ---------- draw ----------
  function draw(){
    ctx.clearRect(0,0,W,H);
    let ox=0, oy=0;
    if(G.shake>0){ const m=G.shake*7; ox=rnd(-m,m); oy=rnd(-m,m); }
    ctx.save(); ctx.translate(ox,oy);

    // Background image — NYC street scene (scrolling)
    if(bgImg.complete && bgImg.naturalWidth){
      const imgAspect = bgImg.naturalWidth / bgImg.naturalHeight;
      const imgH = ground / 0.62;
      const imgW = imgH * imgAspect;
      // Pan at 30% of game speed so background parallaxes behind obstacles
      const scroll = (G.dist * 0.30) % imgW;
      // Draw two copies side-by-side for seamless tiling
      ctx.drawImage(bgImg, -scroll,        0, imgW, imgH);
      ctx.drawImage(bgImg, imgW - scroll,  0, imgW, imgH);
      // subtle dark overlay to pop game elements
      ctx.fillStyle = "rgba(0,0,0,0.18)";
      ctx.fillRect(-20, 0, W+40, ground);
    } else {
      drawSky();
      drawClouds();
      drawCity();
      const hz=ctx.createLinearGradient(0,ground-120,0,ground);
      hz.addColorStop(0,"rgba(201,228,244,0)"); hz.addColorStop(1,"rgba(201,228,244,.4)");
      ctx.fillStyle=hz; ctx.fillRect(-20,ground-120,W+40,120);
    }

    // ground
    drawGround();
    // street steam
    drawSteam();
    // entities
    drawCones();
    drawTaxis();
    drawDrops();
    drawRunner();
    drawParticles();
    drawFloats();

    ctx.restore();
  }

  function wrapX(base, x, span){ // returns x position wrapped across W
    let v = x + ((base % span)+span)%span;
    return v;
  }
  function drawSky(){
    const g=ctx.createLinearGradient(0,0,0,ground);
    g.addColorStop(0,"#3f9fe6"); g.addColorStop(.55,"#6fbef0"); g.addColorStop(1,"#bfe3f6");
    ctx.fillStyle=g; ctx.fillRect(-20,0,W+40,ground+2);
    const s=ctx.createRadialGradient(W*0.16,H*0.1,8,W*0.16,H*0.1,280);
    s.addColorStop(0,"rgba(255,248,222,.8)"); s.addColorStop(1,"rgba(255,248,222,0)");
    ctx.fillStyle=s; ctx.beginPath(); ctx.arc(W*0.16,H*0.1,280,0,6.28); ctx.fill();
  }
  function puff(x,y,s){
    for(const o of [[0,2,26],[26,8,20],[-26,8,20],[12,-10,19],[-14,-8,16],[46,10,14],[-46,10,14]]){
      ctx.beginPath(); ctx.arc(x+o[0]*s, y+o[1]*s, o[2]*s, 0, 6.28); ctx.fill();
    }
  }
  function drawClouds(){
    const span=W+260;
    for(const c of clouds){
      let x=((c.x - cloudPar*0.05)%span+span)%span -120;
      ctx.fillStyle="rgba(255,255,255,.5)"; puff(x, c.y+5*c.s, c.s);      // soft underside
      ctx.fillStyle="rgba(255,255,255,.95)"; puff(x, c.y, c.s);
    }
  }
  function blitLayer(arr, span, off){
    off=((off%span)+span)%span;
    for(const it of arr){
      const base=it.x-off;
      for(const sx of [base-span, base, base+span]){
        if(sx<W && sx+it.w>0) ctx.drawImage(it.b.canvas, sx, ground-it.b.h, it.w, it.b.h);
      }
    }
  }
  function drawCity(){
    blitLayer(cityFar, cityFarSpan, -parFar);
    blitLayer(cityNear, cityNearSpan, -parNear);
  }
  function drawSteam(){
    for(const s of G.steam){
      const p=s.age/s.life, a=(1-p)*0.2, r=s.r0*(1+p*2.6);
      ctx.globalAlpha=a; ctx.drawImage(STEAM_GLOW, s.x-r, s.y-r, r*2, r*2);
    }
    ctx.globalAlpha=1;
  }
  function drawMid(){}
  function drawGround(){
    // sidewalk strip where buildings meet the street
    ctx.fillStyle="#a3a8ad"; ctx.fillRect(-20,ground,W+40,9);
    ctx.fillStyle="#7f858b"; ctx.fillRect(-20,ground+9,W+40,2);
    // daytime asphalt
    if(!groundGrad || groundGradH!==H){ groundGrad=ctx.createLinearGradient(0,ground+11,0,H); groundGrad.addColorStop(0,"#42474e"); groundGrad.addColorStop(1,"#2c3036"); groundGradH=H; }
    ctx.fillStyle=groundGrad; ctx.fillRect(-20,ground+11,W+40,H-ground-11);
    // dashed center line (NYC yellow)
    ctx.strokeStyle="rgba(242,202,84,.6)"; ctx.lineWidth=4; ctx.setLineDash([34,30]);
    const off = ((parGround*1.1)%64+64)%64;
    const ly = ground+11+(H-ground-11)*0.55;
    ctx.beginPath(); ctx.moveTo(-off, ly); ctx.lineTo(W, ly); ctx.stroke();
    ctx.setLineDash([]);
  }

  function star(cx,cy,R0,r0,n){
    ctx.beginPath();
    for(let i=0;i<n*2;i++){ const ang=-Math.PI/2 + i*Math.PI/n, rad=i%2?r0:R0;
      ctx.lineTo(cx+Math.cos(ang)*rad, cy+Math.sin(ang)*rad); }
    ctx.closePath(); ctx.fill();
  }
  function drawDrops(){ // coin sprites from asset sheet
    for(const d of G.drops){
      const y = d.y + Math.sin(d.bob)*5;
      const size = d.r * 2.4;
      // glow (cached sprite)
      ctx.drawImage(COIN_GLOW, d.x-size, y-size, size*2, size*2);
      // coin sprite with flip animation
      if(SP.coin.complete && SP.coin.naturalWidth){
        const flip = Math.max(0.15, Math.abs(Math.cos(d.spin)));
        ctx.save();
        ctx.translate(d.x, y);
        ctx.scale(flip, 1);
        ctx.drawImage(SP.coin, -size/2, -size/2, size, size);
        ctx.restore();
      }
    }
  }

  function drawTaxis(){ // wide obstacle: cement barrier
    for(const t of G.taxis){
      const x=t.x, y=ground, w=t.w, h=t.h;
      ctx.save();
      ctx.fillStyle="rgba(0,0,0,.3)"; ctx.beginPath(); ctx.ellipse(x+w/2,y,w*0.54,5,0,0,6.28); ctx.fill();
      if(SP.crate.complete && SP.crate.naturalWidth){
        const dw = w+6, dh = dw/1.439;
        ctx.drawImage(SP.crate, x+w/2-dw/2, y-dh, dw, dh);
      } else {
        ctx.fillStyle="#9aa0aa"; rr(ctx, x, y-h, w, h, 4); ctx.fill();
      }
      ctx.restore();
    }
  }
  function drawCones(){ // ground obstacles: traffic cone or blue tin
    for(const c of G.cones){
      const x=c.x, y=ground, w=c.w;
      ctx.save();
      ctx.fillStyle="rgba(0,0,0,.35)";
      ctx.beginPath(); ctx.ellipse(x+w/2, y, w*.6, 5, 0,0,6.28); ctx.fill();
      const isTin = c.kind==='tin';
      const sp = isTin ? SP.barrel : SP.cone;
      const ratio = isTin ? 0.691 : 0.8;
      if(sp && sp.complete && sp.naturalWidth){
        const dw = isTin ? w+12 : w+10;
        const dh = dw/ratio;
        ctx.drawImage(sp, x+w/2-dw/2, y-dh, dw, dh);
      } else {
        ctx.fillStyle = isTin ? "#1e5fd6" : "#FF6A2B";
        rr(ctx, x+w*.20, y-w*1.3, w*.6, w*1.3, 4); ctx.fill();
      }
      ctx.restore();
    }
  }

  function drawRunner(){ // blue hoodie boy
    const cx=R.x+R.w/2, by=R.y+R.h;
    const sh = R.onGround?1:Math.max(.3,1-(ground-by)/240);

    // --- speed lines ---
    if(G.state==="playing" && R.onGround && G.speed > 200){
      const alpha = Math.min(0.55, (G.speed-200)/600);
      ctx.save(); ctx.globalAlpha = alpha;
      for(let i=0;i<5;i++){
        const ly = R.y + R.h*0.4 + i*(R.h*0.4/5);
        const len = 24 + i*8 + Math.sin(R.runT*3+i)*10;
        ctx.fillStyle = i%2===0 ? "#1e88e5" : "rgba(255,255,255,0.7)";
        ctx.fillRect(R.x - 14 - len, ly, len, 1.8);
      }
      ctx.restore();
    }

    // --- shadow ---
    ctx.fillStyle=`rgba(0,0,0,${.3*sh})`;
    ctx.beginPath(); ctx.ellipse(cx, ground, R.w*.46*sh, 6*sh, 0,0,6.28); ctx.fill();
    if(!charReady()) return;

    // ONE intact sprite, never sliced — no size pop on jump/landing
    const sprite = SP.run;
    const dh = R.h, dw = R.w, ay = -dh;

    // --- motion ghost trail when airborne ---
    if(!R.onGround && G.state==="playing"){
      ctx.save(); ctx.globalAlpha = 0.18;
      for(let t=1;t<=2;t++){
        ctx.drawImage(sprite, cx-t*12-dw/2, by+t*4+ay, dw, dh);
      }
      ctx.restore();
    }

    // --- main sprite on skateboard ---
    ctx.save();
    ctx.translate(cx, by);
    const push = R.runT*2.2;
    const bobAmp = R.onGround ? Math.min(4.5, 2 + G.speed/150) : 0;
    const bob = R.onGround ? (Math.cos(push)*0.5+0.5)*bobAmp : 0;
    ctx.translate(0, bob);
    const LIFT = 12;                    // board height: rider stands on the deck
    ctx.translate(0, -LIFT);
    // squash on the push / stretch on the ollie
    const sq = R.onGround ? 1 + Math.cos(push)*0.030 : 1 - Math.max(-0.05, Math.min(0.05, R.vy/9000));
    ctx.scale(R.sx*(2-sq), R.sy*sq);
    const carve = R.onGround ? Math.sin(push)*0.055 : 0;
    const airTilt = !R.onGround ? Math.max(-.30, Math.min(.20, R.vy/3600)) : 0;
    ctx.rotate(carve + airTilt);
    drawBoard(R.w*1.06, LIFT);         // board rolls under the feet (ground at y=+LIFT)
    const flash = (G.invuln>0 && Math.floor(G.invuln*16)%2===0);
    ctx.globalAlpha = flash?0.5:1;
    ctx.drawImage(sprite, -dw/2, ay, dw, dh);
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  function drawBoard(boardW, LIFT){
    const deckW = boardW;
    const wheelR = 4.5;
    const axleY = LIFT - wheelR;        // wheel centre (wheel bottom rests on ground y=+LIFT)
    const deckBottom = axleY - 3;       // truck height
    const deckThk = 4.5;
    const deckTop = deckBottom - deckThk;
    const L = -deckW/2, R2 = deckW/2;
    const inset = deckW*0.19;
    const wx1 = L+inset, wx2 = R2-inset;
    // deck (Street Origins red, kicked look) with edge shadow + top highlight
    ctx.fillStyle="#111318";
    rr(ctx, L, deckTop-1.4, deckW, deckThk+2.2, deckThk/2+1); ctx.fill();
    ctx.fillStyle="#E11D3A";
    rr(ctx, L, deckTop, deckW, deckThk, deckThk/2); ctx.fill();
    ctx.fillStyle="rgba(255,255,255,.30)";
    rr(ctx, L+3, deckTop+0.6, deckW-6, 1.5, 1); ctx.fill();
    // trucks (silver)
    ctx.fillStyle="#b7bcc4";
    ctx.fillRect(wx1-1.6, deckBottom-1, 3.2, axleY-deckBottom+1);
    ctx.fillRect(wx2-1.6, deckBottom-1, 3.2, axleY-deckBottom+1);
    ctx.fillRect(wx1-6.5, axleY-1.3, 13, 2.6);
    ctx.fillRect(wx2-6.5, axleY-1.3, 13, 2.6);
    // wheels (gold, spinning with distance)
    const spin = (G.dist||0)*0.05;
    for(const wx of [wx1,wx2]){
      ctx.fillStyle="#FFC21F";
      ctx.beginPath(); ctx.arc(wx, axleY, wheelR, 0, 6.28); ctx.fill();
      ctx.lineWidth=1.3; ctx.strokeStyle="#a8730a";
      ctx.beginPath(); ctx.arc(wx, axleY, wheelR, 0, 6.28); ctx.stroke();
      ctx.save(); ctx.translate(wx,axleY); ctx.rotate(spin);
      ctx.strokeStyle="#7a5207"; ctx.lineWidth=1.1;
      ctx.beginPath(); ctx.moveTo(-wheelR*.72,0); ctx.lineTo(wheelR*.72,0);
      ctx.moveTo(0,-wheelR*.72); ctx.lineTo(0,wheelR*.72); ctx.stroke();
      ctx.restore();
    }
  }

  function drawParticles(){
    for(const p of G.parts){ const a=1-p.age/p.life; ctx.fillStyle=p.col+a+")";
      ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,6.28); ctx.fill(); }
  }
  function drawFloats(){
    ctx.textAlign="center"; ctx.font="700 16px 'Unbounded',sans-serif";
    for(const f of G.floats){ const a=1-f.age/f.life;
      ctx.fillStyle="rgba(255,205,110,"+a+")"; ctx.fillText(f.txt, f.x, f.y); }
  }

  // ---------- loop ----------
  let last=performance.now();
  function frame(now){
    let dt=(now-last)/1000; last=now;
    if(dt>1/30) dt=1/30;
    if(G.state==="playing") update(dt);
    draw();
    requestAnimationFrame(frame);
  }

  // init
  window.addEventListener("resize", ()=>{ resize(); R.x=W*0.20; resetRunner(); });
  resize(); R.x=W*0.20; resetRunner(); syncLives(); syncHUD();
  { const hs=byId("hiScore"); if(hs) hs.textContent=G.best.toLocaleString(); }
  if(reduceMotion){
    // still allow play, but don't auto-animate background heavily; user can press start
    startBtn.textContent = T.startLabelReduced || "Tap to run";
  }
  requestAnimationFrame(frame);

  // claim flow entry points
  sumJoin.addEventListener("click", openClaim);
  byId("chipJoin").addEventListener("click", e=>{ e.preventDefault(); openClaim(); });

  // populate username dropdown immediately on load
  renderNameSuggestions();
})();